export const title = process.env.NODE_TITLE || '酒店后台';
export const titleName = process.env.NODE_TITLE_NAME || '同舟智慧酒店管理后台';
export const companyName = process.env.NODE_COMPANY_NAME || '同舟';
export const appletName = process.env.NODE_APPLET_NAME || '同舟智慧酒店客房服务助手';



// WEBPACK FOOTER //
// ./src/api/text.js